import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    openOnDesktop: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label for the action that opens the asset in the desktop app */
            openOnDesktop: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useOpenOnDesktopAction.openOnDesktop?c=st41s5g1s476", defaultMessage: "Open on Desktop" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
